module.exports = __webpack_public_path__ + "img/T1A_rc_8.caf974dd.png";